import { render, staticRenderFns } from "./DeskImage.vue?vue&type=template&id=31bc000e&"
import script from "./DeskImage.vue?vue&type=script&lang=js&"
export * from "./DeskImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports